import React from "react";
import { Link } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import {  Service1Img } from "../../Constant/Index";

const SingleService = () => {

    return (
        <>
            <Header />
            <UniversalBanner heading="Services" />
            <section className="about-text-section">
                <div className="container">
                    <div className="about-text-start">
                        <div className="col-lg-11 mx-auto">
                            <div className="row">
                                <div className="col-sm-6 pe-lg-5 pt-5 pt-lg-0"  data-aos="fade-left" data-aos-duration="1400">
                                    <figure className="with-bg radius-0">
                                        <img src={Service1Img} className="w-100 with-radius-sm" alt="" />
                                    </figure>
                                </div>
                                <div className="col-sm-6 ps-lg-0 d-flex flex-column justify-content-center pt-4 pt-sm-0"  data-aos="fade-right" data-aos-duration="1400">
                                    <div className="text-here">
                                        <h4 className="md-heading mb-4">Child Psychotherapy</h4>
                                        <p className="text">We understand that seeking help for mental health issues can be intimidating, and that is why we strive to create a welcoming and non-judgmental atmosphere where clients feel comfortable and supported. Whether you are struggling with anxiety, depression, trauma, or any other mental health concern, we are here to provide you with the tools and support you need to move forward and lead a fulfilling, meaningful life</p>
                                        <p className="text yellow-line pt-4">LG Psychotherapy and Counselling is both physical and online therapy</p>
                                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>
                                        <Link className="btn" to="/booking">Book an Appointment</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}
export default SingleService;